// eslint-disable-next-line import/no-mutable-exports
let serverURI = '';

if (process.env.NODE_ENV === 'production') {
  //serverURI = '';
  //serverURI = 'http://192.168.0.140:26000';
  //serverURI = 'http://jay-netlink.iptime.org:26000';
} else {
  //serverURI = 'http://localhost:26000';
  //serverURI = 'http://192.168.0.140:26000';
  //serverURI = 'http://jay-netlink.iptime.org:26000';
}

//serverURI = 'http://175.192.85.64:26200';
//serverURI = 'http://220.72.45.85:26200';
//serverURI = 'http://219.240.88.16:16200';
//serverURI = 'http://localhost:26200';
//serverURI = 'http://119.193.181.46:26000';
//serverURI = 'http://192.168.0.203:26000';
//serverURI = 'http://123.215.113.164:23200';
serverURI = 'http://49.247.171.148:26200';

export default serverURI;
